import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export const BrueckeBewertungen = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 tracking-tight">
            Mehr zum Unfallgutachten
          </h2>
          <p className="text-gray-700 leading-relaxed text-lg mb-8 max-w-2xl mx-auto">
            Wenn Sie wissen möchten, wann ein Unfallgutachten sinnvoll ist und wie der Ablauf aussieht, finden Sie hier alle Details.
          </p>
          <a href="/unfallgutachten">
            <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white text-lg px-10 py-6 rounded-2xl font-semibold">
              Zur Seite Unfallgutachten
              <ArrowRight className="w-5 h-5 ml-3" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};